import { render, staticRenderFns } from "./ValidCheckbox.vue?vue&type=template&id=0819ce4b&scoped=true&"
import script from "./ValidCheckbox.vue?vue&type=script&lang=js&"
export * from "./ValidCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0819ce4b",
  null
  
)

export default component.exports